<ng-template [ngIf]="!loaded">
  <app-skeleton [stats]="'profile'"></app-skeleton>
</ng-template>


<div *ngIf="loaded" class="school-page"
     [class.mobile]="deviceService.isMobile()">
  <div class="header-wrap">
    <app-school-header
      [school]="school"
      [subjectId]="subjectId"
      [isModal]="isModal"
      (onSubjectChange)="setSubjectFromPage($event)">
    </app-school-header>
  </div>

  <div class="additional-info" [class.loading]="freezeTimer">
    <div id="school-content"></div>

    <div #navPosition [class.scroll]="deviceService.isMobile() || deviceService.isTablet()"
         [ngStyle]="{'top': topFromHeader + 'px'}"
         [class.stuck-shadow]="stuckState"
         [class.modal]="isModal" class="school-tabs">
      <div (click)="setActiveTab(item)"
           *ngFor="let item of tabs; let i = index; trackBy: trackByFn" class="categories-item">
        <a class="tab" [class.active]="pathName === item.code"
           itemprop="url">
          <span class="tab-name">{{ item.title | customLocale }}</span>
        </a>
      </div>
    </div>

    <div class="school-content" [class.mobile]="deviceService.isMobile()" [class.tablet]="deviceService.isTablet()">
      <!-- Main tab -->
      <ng-container *ngIf="pathName === 'main'">
        <ng-container *ngTemplateOutlet="pathMain"></ng-container>
        <ng-container *ngTemplateOutlet="pathSchoolTutors"></ng-container>
        <ng-container *ngTemplateOutlet="pathSchoolClasses"></ng-container>
        <ng-container *ngTemplateOutlet="pathFeedBack"></ng-container>
      </ng-container>

      <ng-container *ngIf="pathName === 'school-tutors'">
        <ng-container *ngTemplateOutlet="pathSchoolTutors"></ng-container>
      </ng-container>

      <ng-container *ngIf="pathName === 'school-classes'">
        <ng-container *ngTemplateOutlet="pathSchoolClasses"></ng-container>
      </ng-container>

      <ng-container *ngIf="pathName === 'educational-material'">
        <ng-container *ngTemplateOutlet="pathEducationMaterial"></ng-container>
      </ng-container>

      <ng-container *ngIf="pathName === 'feed'">
        <ng-container *ngTemplateOutlet="pathFeed"></ng-container>
      </ng-container>

      <ng-container *ngIf="pathName === 'feedback'">
        <ng-container *ngTemplateOutlet="pathFeedBack"></ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #pathMain>
  <div class="title-block" [ngClass]="{ visibility: getVisibility('main') }">
    <div class="title">
      <app-title [title]="'school-steps.about'"></app-title>
    </div>
    <span [innerHTML]="description" class="about"></span>
  </div>
</ng-template>

<!-- Tutors tab -->
<ng-template #pathSchoolTutors>
  <ng-container *ngIf="loaded && (hasTutors || meIsOwnerSchool)">
  <div class="pane-block" [ngClass]="{ visibility: getVisibility('school-tutors') || getVisibility('main') }">
    <div class="title">
      <app-title [title]="'school-main-tabs.tutors'"></app-title>
    </div>
    <ng-template [ngIf]="hasTutors" [ngIfElse]="emptyTutors">
      <app-pane [item]="tutors" (loadFinished)="afterLoaded()"></app-pane>
    </ng-template>
    <ng-template #emptyTutors>
      <app-empty [empty]="emptyTutorsContent"></app-empty>
    </ng-template>
  </div>
  </ng-container>
</ng-template>

<!-- Classes tab -->
<ng-template #pathSchoolClasses>
  <ng-container *ngIf="loaded && (hasClasses || meIsOwnerSchool)">
  <app-school-classes
    [ngClass]="{ visibility: getVisibility('school-classes') || getVisibility('main'),
    'non-visible': !getVisibility('school-classes') && !getVisibility('main')}"
    [school]="school"
    [subjectId]="subjectId"
    (loaded)="afterLoaded()"></app-school-classes>
  </ng-container>
</ng-template>

<!-- Lessons tab -->
<ng-template #pathEducationMaterial>
  <ng-container *ngIf="loaded && (hasLessons || meIsOwnerSchool)">
  <div class="educational-material" [ngClass]="{ visibility: getVisibility('educational-material'),
    'non-visible': !getVisibility('educational-material') }">
    <div class="title">
      <app-title [title]="'school-main-tabs.educational-material'">
        <ng-container *ngIf="meIsOwnerSchool" side>
        <span class="title-link" (click)="showContentSelector()">
          {{ 'school-main-tabs.add-educational-material' | customLocale }}
        </span>
        </ng-container>
      </app-title>
    </div>
    <app-pane [item]="lessons" (loadFinished)="checkIfHasLessons($event)"></app-pane>
    <ng-template [ngIf]="!hasLessons">
      <app-empty [empty]="emptyLessonsContent" (onClick)="showContentSelector()"></app-empty>
    </ng-template>
  </div>
  </ng-container>
</ng-template>

<!-- Feed tab -->
<ng-template #pathFeed>
  <ng-container *ngIf="loaded">
  <app-school-feed
    [ngClass]="{ visibility: getVisibility('feed'),
    'non-visible': !getVisibility('feed') }"
    [school]="school" (loaded)="afterLoaded()"></app-school-feed>
  </ng-container>
</ng-template>

<!-- Feedback tab -->
<ng-template #pathFeedBack>
  <ng-container *ngIf="loaded && (hasFeedback || meIsOwnerSchool)">
  <div class="pane-block"
       [ngClass]="{ visibility: getVisibility('feedback') || getVisibility('main'),
    'non-visible': !getVisibility('feedback') && !getVisibility('main') }">
    <div class="title">
      <app-title [title]="'school-main-tabs.feedback'"></app-title>
    </div>
    <ng-template [ngIf]="hasFeedback" [ngIfElse]="emptyFeedback">
      <app-meeting-review-form
        *ngFor="let meetingReview of reviews; trackBy: trackReviewByFn"
        [meetingReview]="meetingReview" (loaded)="afterLoaded()">
      </app-meeting-review-form>
    </ng-template>
    <ng-template #emptyFeedback>
      <app-empty [empty]="emptyFeedbackContent"></app-empty>
    </ng-template>
  </div>
  </ng-container>
</ng-template>

<app-content-selector *ngIf="isContentSelectorOpened"
                      [selectedLessons]="lessonsItems"
                      [visible]="isContentSelectorVisible"
                      (closed)="hideContentSelector()"
                      (selected)="addContent($event)"
></app-content-selector>
